import { useEffect, useState } from "react";
import "./UpdateNotification.css";  // import the CSS file

const UpdateNotification = () => {
  const [showUpdate, setShowUpdate] = useState(false);

  useEffect(() => {
    if (!navigator?.serviceWorker) return;

    const handleControllerChange = () => {
      setShowUpdate(true);
    };

    navigator.serviceWorker.addEventListener("controllerchange", handleControllerChange);

    return () => {
      navigator.serviceWorker.removeEventListener("controllerchange", handleControllerChange);
    };
  }, []);

  const handleRefresh = () => {
    if (navigator?.serviceWorker?.controller) {
      navigator.serviceWorker.controller.postMessage({ type: "SKIP_WAITING" });
    }
    window.location.reload();
  };

  return (
    showUpdate && (
      <div className="update-notification">
        <p>A new version is available!</p>
        <button onClick={handleRefresh}>Refresh</button>
      </div>
    )
  );
};

export default UpdateNotification;
